export const scrollToDrawerTop = () => document.querySelector('.DrawerContent-root')?.scrollTo(0, 0)
